<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col cols='12' sm="4">
          <b-form-group v-bind:label="$t('date_range')" :label-cols="3" label-class="text-right" :horizontal="true">
            <date-range-picker :startDate="startDate" :endDate="endDate" @update="updateDateRange" opens="right" :localeData="{ format: 'DD/MM/YYYY' }"></date-range-picker>
          </b-form-group>
        </b-col>
        <b-col cols='12' sm="4">
          <b-form-group v-bind:label="$t('outlet')" :label-cols="3" label-class="text-right" :horizontal="true">
            <b-form-select v-model="outlet"  :options="[{text: $t('all'), value: null}, {text: 'Outlet 1', value: 1}, {text: 'Outlet 2', value: 2}]">
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols='12' sm="4">
          <b-form-group v-bind:label="$t('type')" :label-cols="3" label-class="text-right" :horizontal="true">
            <b-form-select v-model="type"  :options="[{text: $t('daily'), value: 'daily'}, {text: $t('weekly'), value: 'weekly'}, {text: $t('monthly'), value: 'monthly'}]">
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols='12' sm="12">
          <div class="process-container bg-secondary">
            <div class="current bg-primary" :style="'width: ' + current + '%'"></div>
            <div class="target bg-danger" id="target" :style="'margin-left: ' + target + '%'"></div>
            <b-tooltip :show.sync="show_target" target="target" placement="bottom">
              {{target_sales | numeral('0,0')}}
            </b-tooltip>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-row>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <div class="float-right">
              <i class="fa fa-money"></i>
            </div>
            <h4 class="mb-0">{{total_sales | numeral('0,0')}}</h4>
            <p>{{$t('total_sale')}}</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <div class="float-right">
              <i class="fa fa-shopping-basket"></i>
            </div>
            <h4 class="mb-0">{{total_cheque | numeral('0,0')}}</h4>
            <p>{{$t('total_cheque')}}</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <div class="float-right">
              <i class="fa fa-bar-chart"></i>
            </div>
            <h4 class="mb-0">{{total_sales/total_cheque | numeral('0,0.00')}}</h4>
            <p>{{$t('average_cheque')}}</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <div class="float-right">
              <i class="fa fa-bullhorn"></i>
            </div>
            <h4 class="mb-0">{{sos | numeral('0,0.00')}}</h4>
            <p>{{$t('sos')}}</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="12" lg="6">
        <bar :labels="sale_trend_labels[$session.get('lang')]" :datasets="sale_trend_datasets[$session.get('lang')]"/>
        <div class="full-width text-center bg-gray-100 chart-title">
          <h2>{{$t('sales_trend')}}</h2>
        </div>
      </b-col>

      <b-col sm="12" lg="6">
        <bar :labels="cheque_trend_labels[$session.get('lang')]" :datasets="cheque_trend_datasets[$session.get('lang')]"/>
        <div class="full-width text-center bg-gray-100 chart-title">
          <h2>{{$t('cheque_trend')}}</h2>
        </div>
      </b-col>

      <b-col sm="12">
        <hr/>
      </b-col>

      <b-col sm="12" lg="6">
        <pie :labels="sale_by_channel_labels[$session.get('lang')]" :datasets="sale_by_channel_datasets[$session.get('lang')]"/>
        <div class="full-width text-center bg-gray-100 chart-title">
          <h2>{{$t('sales_by_channel')}}</h2>
        </div>
      </b-col>

      <b-col sm="12">
        <hr/>
      </b-col>
    </b-row>
  </div>
</template>
<style scoped>
  .process-container {
    width: 100%;
    height: 35px;
  }
  .process-container .current {
    height: 35px;
    -webkit-transition: width 1s; /* Safari */
    transition:width 1s;
  }
  .process-container .target {
    width: 2px;
    height: 35px;
    margin-top: -35px;
    -webkit-transition: margin-left 1s; /* Safari */
    transition: margin-left 1s;
  }
  .chart-title {
    color: #6c6c6c;
    padding: 5px;
  }
</style>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import Bar from './charts/Bar'
import Pie from './charts/Pie'

export default {
  name: 'report',
  components: {
    DateRangePicker,
    Bar,
    Pie
  },
  data: function () {
    return {
      startDate: this.$moment().format('YYYY-MM-DD'),
      endDate: this.$moment().subtract(7, 'day').format('YYYY-MM-DD'),
      outlet: null,
      type: 'weekly',
      permissions: {},
      total_sales: 736254122,
      total_cheque: 231233,
      sos: 90.23,
      target_sales: 632562541,
      current: 0,
      target: 100,
      show_target: true,
      bar_data: {
        label: '',
        backgroundColor: '#20a8d8',
        data: []
      },
      bar_line_data: {
        label: '',
        data: [],
        type: 'line',
        pointStyle: 'line',
        backgroundColor: '#f86c6b',
        pointBackgroundColor: '#f86c6b',
        pointBorderColor: '#f86c6b',
        showLine: false,
        fill: false
      },
      pie_data: {
        backgroundColor: [
          '#20a8d8',
          '#f86c6b',
          '#ffc107',
          '#4dbd74',
          '#63c2de',
          '#73818f'
        ],
        data: []
      },
      sale_trend_labels: {},
      sale_trend_datasets: {},
      cheque_trend_labels: {},
      cheque_trend_datasets: {},
      sale_by_channel_labels: {},
      sale_by_channel_datasets: {},
      languages: Object.keys(this.$i18n.messages)
    }
  },
  methods: {
    /**
     * Update date from and date to
     * @param val
     */
    updateDateRange (val) {
      this.startDate = this.$moment(val.startDate).format('YYYY-MM-DD')
      this.endDate = this.$moment(val.endDate).format('YYYY-MM-DD')
      this.updateData()
    },
    /**
     * Update data
     */
    updateData () {
      let from = this.$moment(this.startDate, 'YYYY-MM-DD')
      let to = this.$moment(this.endDate, 'YYYY-MM-DD')
      let diff = from.diff(to, 'days')
      this.total_cheque = (Math.floor((Math.random() * 50) + 1) + 50) * diff
      this.target_sales = this.total_cheque * (Math.floor((Math.random() * 5) + 1) + 80)
      this.total_sales = this.total_cheque * (Math.floor((Math.random() * 50) + 1) + 70)
      this.sos = (Math.floor((Math.random() * 15) + 1) + 85)
      let online = (Math.floor((Math.random() * 10) + 1) + 20) * diff
      let offline = (Math.floor((Math.random() * 10) + 1) + 15) * diff
      let callcenter = (Math.floor((Math.random() * 10) + 1) + 10) * diff
      let aggregator = (Math.floor((Math.random() * 10) + 1) + 5) * diff
      for (let i in this.languages) {
        this.sale_by_channel_datasets[this.languages[i]][0].data = [online, callcenter, offline, aggregator]
      }
      this.updateProcess()
    },
    /**
     * Update data by type
     */
    updateDataByType () {
      if (this.type == 'daily') {
        let saleData = []
        let saleTarget = []
        let chequeData = []
        let chequeTarget = []
        for (let i = 11; i >= 0; i--) {
          saleData.push(Math.floor((Math.random() * 50) + 1) + 65)
          saleTarget.push(Math.floor((Math.random() * 5) + 1) + 80)
          chequeData.push(Math.floor((Math.random() * 50) + 1) + 65)
          chequeTarget.push(Math.floor((Math.random() * 5) + 1) + 80)
        }

        for (let i in this.languages) {
          this.sale_trend_datasets[this.languages[i]][0].data = saleTarget
          this.sale_trend_datasets[this.languages[i]][1].data = saleData
          this.cheque_trend_datasets[this.languages[i]][0].data = chequeTarget
          this.cheque_trend_datasets[this.languages[i]][1].data = chequeData
        }
      } else if (this.type == 'weekly') {
        let saleData = []
        let saleTarget = []
        let chequeData = []
        let chequeTarget = []

        for (let i in this.languages) {
          this.sale_trend_labels[this.languages[i]] = []
          this.cheque_trend_labels[this.languages[i]] = []
        }

        for (let i = 11; i >= 0; i--) {
          saleData.push((Math.floor((Math.random() * 50) + 1) + 50) * 7)
          saleTarget.push((Math.floor((Math.random() * 5) + 1) + 80) * 7)
          chequeData.push((Math.floor((Math.random() * 50) + 1) + 50) * 7)
          chequeTarget.push((Math.floor((Math.random() * 5) + 1) + 80) * 7)
        }

        for (let i in this.languages) {
          this.sale_trend_datasets[this.languages[i]][0].data = saleTarget
          this.sale_trend_datasets[this.languages[i]][1].data = saleData
          this.cheque_trend_datasets[this.languages[i]][0].data = chequeTarget
          this.cheque_trend_datasets[this.languages[i]][1].data = chequeData
        }
      } else if (this.type == 'monthly') {
        let saleData = []
        let saleTarget = []
        let chequeData = []
        let chequeTarget = []

        for (let i in this.languages) {
          this.sale_trend_labels[this.languages[i]] = []
          this.cheque_trend_labels[this.languages[i]] = []
        }
        for (let i = 11; i >= 0; i--) {
          saleData.push((Math.floor((Math.random() * 50) + 1) + 50) * 30)
          saleTarget.push((Math.floor((Math.random() * 5) + 1) + 80) * 30)
          chequeData.push((Math.floor((Math.random() * 50) + 1) + 50) * 30)
          chequeTarget.push((Math.floor((Math.random() * 5) + 1) + 80) * 30)
        }

        for (let i in this.languages) {
          this.sale_trend_datasets[this.languages[i]][0].data = saleTarget
          this.sale_trend_datasets[this.languages[i]][1].data = saleData
          this.cheque_trend_datasets[this.languages[i]][0].data = chequeTarget
          this.cheque_trend_datasets[this.languages[i]][1].data = chequeData
        }
      }
    },
    /**
     * Update current and target sale
     */
    updateProcess () {
      this.show_target = false
      let goal = this.total_sales > this.target_sales ? this.total_sales : this.target_sales
      this.current = this.total_sales * 100 / goal
      this.target = this.target_sales * 100 / goal
      setTimeout(() => {
        this.show_target = true
      }, 1000)
    },
    /**
     * Update label of bar chart
     * @param mode
     */
    updateLabel () {
      let dates = []
      let dbDates = []
      if (this.type == 'daily') {
        for (let i = 11; i >= 0; i--) {
          let date = this.$moment().subtract(i, 'day')
          dates.push(date.format('DD-MM-YYYY'))
          dbDates.push({
            start: date.format('YYYY-MM-DD') + ' 00:00:00',
            end: date.format('YYYY-MM-DD') + ' 23:59:59'
          })
        }

        for (let i in this.languages) {
          this.sale_trend_labels[this.languages[i]] = dates
          this.cheque_trend_labels[this.languages[i]] = dates
        }
      } else if (this.type == 'weekly') {
        for (let i in this.languages) {
          this.sale_trend_labels[this.languages[i]] = []
          this.cheque_trend_labels[this.languages[i]] = []
        }

        for (let i = 11; i >= 0; i--) {
          let date = this.$moment().subtract(i * 7, 'day')

          for (let i in this.languages) {
            this.sale_trend_labels[this.languages[i]].push(this.$t(date.format('Wo').toLowerCase(), this.languages[i]))
            this.cheque_trend_labels[this.languages[i]].push(this.$t(date.format('Wo').toLowerCase(), this.languages[i]))
          }

          dbDates.push({
            start: date.startOf('week').format('YYYY-MM-DD') + ' 00:00:00',
            end: date.endOf('week').format('YYYY-MM-DD') + ' 23:59:59'
          })
        }
      } else if (this.type == 'monthly') {
        for (let i in this.languages) {
          this.sale_trend_labels[this.languages[i]] = []
          this.cheque_trend_labels[this.languages[i]] = []
        }
        for (let i = 11; i >= 0; i--) {
          let date = this.$moment().subtract(i, 'month')

          for (let i in this.languages) {
            this.sale_trend_labels[this.languages[i]].push(this.$t(date.format('MMMM').toLowerCase(), this.languages[i]))
            this.cheque_trend_labels[this.languages[i]].push(this.$t(date.format('MMMM').toLowerCase(), this.languages[i]))
          }

          dbDates.push({
            start: date.startOf('month').format('YYYY-MM-DD') + ' 00:00:00',
            end: date.endOf('month').format('YYYY-MM-DD') + ' 23:59:59'
          })
        }
      }
    }
  },
  created: function () {
    for (let i in this.languages) {
      this.sale_trend_labels[this.languages[i]] = []
      this.cheque_trend_labels[this.languages[i]] = []
      let barLineData = this._.cloneDeep(this.bar_line_data)
      barLineData.label = this.$t('target', this.languages[i])
      let barData = this._.cloneDeep(this.bar_data)
      barData.label = this.$t('sales_amount', this.languages[i])
      this.sale_trend_datasets[this.languages[i]] = [
        barLineData,
        barData
      ]
      this.cheque_trend_datasets[this.languages[i]] = [
        barLineData,
        barData
      ]
      this.sale_by_channel_labels[this.languages[i]] = [
        this.$t('online', this.languages[i]),
        this.$t('call_center', this.languages[i]),
        this.$t('offline', this.languages[i]),
        this.$t('aggregator', this.languages[i])
      ]
      let pieData = this._.cloneDeep(this.pie_data)
      this.sale_by_channel_datasets[this.languages[i]] = [
        pieData
      ]
    }
    this.updateDataByType()
    this.updateLabel()
    this.updateData()
    this.permissions = {}
    for (let i in this.$auth.user().permissions) {
      let per = this.$auth.user().permissions[i]
      let array = per.split('.')
      let model = array[0]
      let action = []
      if (this.permissions[model] == null) {
        this.permissions[model] = {
          name: model,
          func: []
        }
      }
      for (let j in array) {
        if (j > 0) {
          action.push(array[j])
        }
      }
      this.permissions[model].func.push(action.join('_'))
    }
  },
  watch: {
    type: function (val) {
      this.updateDataByType()
      this.updateLabel()
    },
    outlet: function (val) {
      this.updateData()
      this.updateDataByType()
      this.updateLabel()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Report.vue